import { z } from 'zod';
/**
 * ADR-029: Гранулярные permissions.
 * Модель OpenCode: allow/deny/ask для каждого тула + glob-паттерны для файлов.
 */
export const PERMISSION_ACTIONS = ['allow', 'deny', 'ask'];
export const permissionActionSchema = z.enum(PERMISSION_ACTIONS);
/**
 * Значение правила:
 * - строка — действие для имени тула / группы / '*'
 * - объект — файловые glob-паттерны → действие (для read/edit/external_directory и
 *   для тул-специфичных файловых правил, например `write_file: {"*.env": "deny"}`)
 */
export const permissionRuleSchema = z.union([
    permissionActionSchema,
    z.record(z.string(), permissionActionSchema),
]);
export const permissionConfigSchema = z.object({
    rules: z.record(z.string(), permissionRuleSchema).prefault({}),
    askTimeoutMs: z.number().int().min(0).default(30_000),
});
